import React from 'react'
import SortIcon from '@material-ui/icons/Sort'
import cx from 'classnames'
import { observePageState } from 'front-end-core/services/PageStateService'
import connect from 'components/shared/connect'
import { map } from 'rxjs/operators'

const Actions = (props) => {
  const { commentCount, pageLength, sortValue, sortLink, page } = props
  return (!commentCount
    ? null
    : (
      <>
        {sortValue && <SortByControls {...{ sortValue, sortLink }} />}
        <div className='flex items-center'>
          <PaginationHeader {...{ page, commentCount, pageLength }} />
          {/*
        TODO: fix button behaviour
        <PrintIconButton {...props} />
        <DownloadIconButton {...props} />
        */}
        </div>
      </>
      ))
}

const PaginationHeader = ({ page, commentCount, pageLength }) => (
  <span className='mr6 f6-m'>
    Page {page} of {Math.ceil(commentCount / pageLength)}
  </span>
)

const SortByControls = ({ sortValue, sortLink }) => {
  const isLatestSelected = sortValue === 'latest'

  return (
    <span className='flex items-center f6-m'>
      <SortIcon />
      <span className='mh4'>Sort by:</span>
      <a
        className={cx('no-underline outline-0', { black: isLatestSelected }, { 'hover-underline': !isLatestSelected })}
        href={isLatestSelected ? null : sortLink('latest')}
      >
        <span>Latest</span>
      </a>
      <span className='mh2'>
        {' | '}
      </span>
      <a
        className={cx('no-underline outline-0', { black: !isLatestSelected }, { 'hover-underline': isLatestSelected })}
        href={isLatestSelected ? sortLink('oldest') : null}
      >
        Oldest
      </a>
    </span>
  )
}

export default connect(() => observePageState().pipe(map(state => ({ state }))))(Actions)
